import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./index2.css";
import logopic from '../Pages/images/LM_C_HillerodFrimenighed_rgb.png';
import logopicC from '../Pages/images/LM_C_HillerodFrimenighed_hvid_rgb.png';
import Dropdown from './components/Dropdown.js';
import DropdownMobil from './components/DropdownMobil.js';
import { Link } from "react-router-dom";
import { faellesskabItems } from './components/FaellesskabsItem';
import { gudstjenesteItems } from './components/GudstjenesteItems.js';
import { omOsItems } from "./components/OmOsItems";

function Navbar() {

    const navRef = useRef();
    const headRef = useRef();
    const barNavRef = useRef();
    const menuContainerRef = useRef();

    const [mobileMenu, setMobileMenu] = useState(false);
    const [logo, setLogo] = useState(logopicC);
    const [dropdown1, setDropdown1] = useState(false);
    const [dropdown2, setDropdown2] = useState(false);
    const [dropdown3, setDropdown3] = useState(false);

    const showNavbar = () => {
        navRef.current.classList.toggle("responsive_nav");
    };

    const handleClickMobilMenu = () => {
        setMobileMenu(!mobileMenu);
        barNavRef.current.classList.remove("scrolled");
        showNavbar();
        setDropdown1(false);
        setDropdown2(false);
        setDropdown3(false);
    };

    const handleResize = () => {
        const currentScreenWidth = window.innerWidth;
        if (currentScreenWidth > 1024 && mobileMenu) {
            handleClickMobilMenu();
            showMenuButtons();
        }
    };
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]); // Added handleResize to dependencies

    const handleDropdownEvent = ({ setDropdown, dropdown }) => {
        if (!window.matchMedia('(hover: hover)').matches || mobileMenu) {
            if (mobileMenu) {
                return { onClick: () => handleChooseDropdownMobil({ setDropdown, dropdown }) };
            } else {
                return { onClick: () => handleChooseDropdown({ setDropdown, dropdown }) };
            }
        } else {
            return { onMouseEnter: () => setDropdown(true), onMouseLeave: () => setDropdown(false) };
        }
    };

    const handleChooseDropdown = ({ setDropdown, dropdown }) => {
        setDropdown1(false);
        setDropdown2(false);
        setDropdown3(false);
        setDropdown(!dropdown);
    };

    const handleChooseDropdownMobil = ({ setDropdown, dropdown }) => {
        handleChooseDropdown({ setDropdown, dropdown });
        hideMenuButtons();
    };

    const hideMenuButtons = () => {
        menuContainerRef.current.classList.add("hidden");
    };

    const showMenuButtons = () => {
        menuContainerRef.current.classList.remove("hidden");
    };

    useEffect(() => {
        const handleScroll = () => {
            if (headRef.current && headRef.current.classList) {
                if (window.scrollY > 500) {
                    headRef.current.classList.add("scrolled");
                    setLogo(logopic);
                    menuContainerRef.current.classList.add("scrolled");
                    if (!mobileMenu) {
                        barNavRef.current.classList.add("scrolled");
                    } else {
                        barNavRef.current.classList.remove("scrolled");
                    }
                } else {
                    headRef.current.classList.remove("scrolled");
                    barNavRef.current.classList.remove("scrolled");
                    setLogo(logopicC);
                    menuContainerRef.current.classList.remove("scrolled");
                }
            }
        };
        document.addEventListener("scroll", handleScroll);
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [mobileMenu]);

    return (
        <>
            <header ref={headRef}>
                <Link to="./" className="logo-btn">
                    <img src={logo} alt="logo" className="logopic" />
                </Link>

                <nav ref={navRef} className="navBar">
                    <div ref={menuContainerRef} className="menuContainer">
                        {mobileMenu && <Link to="/" className="navButton" id="link" onClick={handleClickMobilMenu}>FORSIDE</Link>}
                        <Link to="/Kalender" className="Link" onClick={mobileMenu ? handleClickMobilMenu : null}>KALENDER</Link>
                        <button className="navButton" {...handleDropdownEvent({ setDropdown: setDropdown1, dropdown: dropdown1 })}>
                            {!mobileMenu && <Dropdown items={faellesskabItems} dropdown={dropdown1} setDropDown={setDropdown1} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} />}
                            FÆLLESSKABER
                        </button>

                        <button className="navButton" {...handleDropdownEvent({ setDropdown: setDropdown2, dropdown: dropdown2 })}>
                            {!mobileMenu && <Dropdown items={gudstjenesteItems} dropdown={dropdown2} setDropDown={setDropdown2} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} />}
                            GUDSTJENESTE
                        </button>

                        <button className="navButton" {...handleDropdownEvent({ setDropdown: setDropdown3, dropdown: dropdown3 })}>
                            {!mobileMenu && <Dropdown items={omOsItems} dropdown={dropdown3} setDropDown={setDropdown3} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} />}
                            OM OS
                        </button>

                        <Link to="/Kontakt" className="Link" onClick={mobileMenu ? handleClickMobilMenu : null}>KONTAKT</Link>
                    </div>

                    {mobileMenu && (<DropdownMobil items={faellesskabItems} dropdown={dropdown1} setDropDown={setDropdown1} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} showMenuButtons={showMenuButtons} />)}
                    {mobileMenu && (<DropdownMobil items={gudstjenesteItems} dropdown={dropdown2} setDropDown={setDropdown2} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} showMenuButtons={showMenuButtons} />)}
                    {mobileMenu && (<DropdownMobil items={omOsItems} dropdown={dropdown3} setDropDown={setDropdown3} mobileMenu={mobileMenu} handleClickMobilMenu={handleClickMobilMenu} showMenuButtons={showMenuButtons} />)}

                    <button
                        className="nav-btn nav-close-btn"
                        onClick={() => {
                            handleClickMobilMenu();
                            showMenuButtons();
                        }}>
                        <FaTimes />
                    </button>
                </nav>
            </header>

            <button
                ref={barNavRef}
                className="nav-btn"
                onClick={handleClickMobilMenu}>
                {!mobileMenu && <FaBars />}
            </button>
        </>
    );
}

export default Navbar;
